import { takeUntil } from 'rxjs/operators';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { Validacoes } from "src/app/@shared/helpers/validacoes";
import { ClienteOutput } from 'src/app/@shared/models/cliente.model';
import { ClienteService } from 'src/app/services/cliente/cliente.service';
import { AcompanhamentoCorrecoesErrosCteComponent } from '../acompanhamento-correcoes-erros-cte.component';
import { acoesOutput, ConsultaCorrecoesErrosCteModelRequest, statusOutput } from '../acompanhamento-correcoes-erros-cte.model';
import { HttpErrorResponse } from '@angular/common/http';
import { CorrecoesErrosCteService } from 'src/app/services/correcoes-erros-cte/correcoes-erros-cte.service';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-acompanhamento-correcoes-erros-cte-filtros-pesquisa',
  templateUrl: './acompanhamento-correcoes-erros-cte-filtros-pesquisa.html',
  styleUrls: ['./acompanhamento-correcoes-erros-cte-filtros-pesquisa.scss']
})
export class AcompanhamentoCorrecoesErrosCteFiltrosPesquisaComponent implements OnInit {
  @Input() parent: AcompanhamentoCorrecoesErrosCteComponent;
  @Input() formPesquisa;

  private onDestroy = new Subject<void>();


  acoes: acoesOutput[];
  public filteredAcoes: ReplaySubject<acoesOutput[]> = new ReplaySubject<acoesOutput[]>(1);
  public acoesMultiFilter: FormControl = new FormControl();

  status: any[];
  public filteredStatus: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public statusMultiFilter: FormControl = new FormControl();

  clientes: ClienteOutput[];
  public filteredClientes: ReplaySubject<ClienteOutput[]> = new ReplaySubject<ClienteOutput[]>(1);
  public clienteMultiFilter: FormControl = new FormControl();
  clienteID = false;
  listaUsuarios: any;

  public usuario_logado = StorageService.getPerfilUsuario();

  constructor(
    private route: ActivatedRoute,
    public clienteService: ClienteService,
    private service: CorrecoesErrosCteService
  ) { }

  ngOnInit() {
    this.listarClientes();
    this.listarAcoes();
    this.listarStatus();
    this.setaDataInicial();

    this.setValue("usuario", this.usuario_logado.username);

    this.route.queryParams.subscribe(params => {
      if (params['load']) {
        this.trigger();
      }
    });

  }

  setaDataInicial() {
    const filtroFim = new Date();
    const filtroInicio = new Date(filtroFim);
    filtroInicio.setDate(filtroInicio.getDate() - 10);
    this.formPesquisa.get('dataInicio').setValue(filtroInicio);
    this.formPesquisa.get('dataFim').setValue(filtroFim);
  }

  limparCampos() {
    this.formPesquisa.reset();
    this.setValue('clienteId', '');
    this.setValue('statusLote', '');
    this.setValue('acoes', '');

    this.setaDataInicial();
  }

  minChars = 3;
  validar() {
    const charFields = [
      {
        input: "cnpj",
        type: "string",
      },
      {
        input: "dataInicio",
        type: "date",
        interval: "start",
      },
      {
        input: "dataFim",
        type: "date",
        interval: "end",
      },
    ];

    var validateChars = (field) =>
      field.type == "date" ?
        Validacoes.dateDiff(this.getValue("dataInicio"), this.getValue("dataFim"))["d"] >= 0
        // &&
        // Validacoes.dateDiff(this.getValue("dataInicio"), this.getValue("dataFim"))["d"] <= 30
        :
        this.getValue(field.input)?.toString().length >= this.minChars;
    return charFields.some(validateChars);

  }

  getValue(fieldName) {
    return this.formPesquisa?.get(fieldName)?.value;
  }

  setValue(fieldName, value) {
    return this.formPesquisa?.get(fieldName)?.setValue(value);
  }

  public async listarClientes() {
    return this.clienteService.list().toPromise().then((response: ClienteOutput[]) => {
      this.clientes = response.filter(x => x.nome != '').sort((a, b) => (a.nome < b.nome ? -1 : 1));
      this.filteredClientes.next(this.clientes.slice());
      this.clienteMultiFilter.valueChanges
        .pipe(takeUntil(this.onDestroy))
        .subscribe(() => {
          this.filtroGeral(this.clientes, this.clienteMultiFilter, this.filteredClientes, 'nome');
        });
    },
      (err: HttpErrorResponse) => {
        this.parent.openSnackBar('Erro ao carregar clientes, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  public async listarAcoes() {
    return this.service.acoesCte().toPromise().then((response: any) => {
      this.acoes = response.filter(x => x.descricao).sort((a, b) => (a.descricao < b.descricao ? -1 : 1));
      this.filteredAcoes.next(this.acoes.slice());
      this.acoesMultiFilter.valueChanges
        .pipe(takeUntil(this.onDestroy))
        .subscribe(() => {
          this.filtroGeral(this.acoes, this.acoesMultiFilter, this.filteredAcoes, 'descricao')
        });
    },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.parent.openSnackBar('Erro ao carregar Ações, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  };

  public async listarStatus() {
    return this.service.statusCancelamento().toPromise().then((response: any) => {
      this.status = response.filter(x => x.statusDesc).sort((a, b) => (a.statusDesc < b.statusDesc ? -1 : 1));
      this.filteredStatus.next(this.status.slice());
      this.statusMultiFilter.valueChanges
        .pipe(takeUntil(this.onDestroy))
        .subscribe(() => {
          this.filtroGeral(this.status, this.statusMultiFilter, this.filteredStatus, 'status')
        });
    },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.parent.openSnackBar('Erro ao carregar o Status, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  };

  private filtroGeral(filtro: any, multifilter: any, filtered: any, field: string) {
    if (!filtro) {
      return;
    }
    let search = multifilter.value;
    if (!search) {
      filtered.next(filtro.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filtered.next(
      filtro.filter(response => response[field].toLowerCase().indexOf(search) > -1)
    );
  }

  trigger() {
    if (this.validar()) {
      var filters = {
        dataDe: this.getValue("dataInicio") ? this.getValue("dataInicio").toISOString().split("T")[0] : null,
        dataAte: this.getValue("dataFim") ? this.getValue("dataFim").toISOString().split("T")[0] : null,
        clienteId: this.getValue("clienteId"),
        numeroLote: this.getValue("numeroLote"),
        numeroCte: this.getValue("numeroCte"),
        chaveCte: this.getValue("chaveCte"),
        usuario: this.getValue("usuario"),
        statusLoteId: this.getValue("statusLote"),
        tipoAcaoId: this.getValue("acoes"),
        codBarras: this.getValue("codBarras"),
        paginaAtual: 1
      } as ConsultaCorrecoesErrosCteModelRequest;
      this.parent.carregarGrid(filters);
    }
  }
}
